<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Row :gutter="16">
      <Col span="12">
        <Card  :bordered="false" dis-hover style="margin-bottom:10px;" >
          <div slot="title">一级分类</div>
          <a slot="extra" @click="load">刷新</a>
          <Button type="primary" size="small" @click="addpar" v-if="power.indexOf(29)!=-1">增加一级分类</Button>
          <el-table :data="list" size="small" style="width: 100%" >
            <el-table-column prop="name" label="分类名称" :show-tooltip-when-overflow="true">
              <template slot-scope="scope" @click="load2(scope.row.id)">
                <span v-if="scope.row.id==pid" ><a @click="load2(scope.row.id)"  style="color:red">{{scope.row.name}}</a></span>
                <span v-else><a style="color:#808695" @click="load2(scope.row.id)">{{scope.row.name}}</a></span>
              </template>
            </el-table-column>

            <el-table-column prop="fid" label="操作" width="100">
              <template slot-scope="scope">
                <a @click="remove(scope.row.i1)" v-if="power.indexOf(30)!=-1">删除</a>
                <cite>|</cite>
                <a @click="edit(scope.row)" v-if="power.indexOf(29)!=-1">编辑</a>
              </template>
            </el-table-column>
          </el-table>

        </Card>
      </Col>

    </Row>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="120">
        <FormItem label="分类名称" required>
          <Input v-model="detail.name" placeholder=""/>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
export default {
  data(){
    return{
      power:this.$storage.getSession('power'),
      baseUrl:'/api/ziliao/ziliaoFenlei/',
      list:[],//一级分类目录
      pid:0,
      list2:[],//子级目录
      detail:{name:'',pid:0},
      modal1:false,
      type:'线下课',
    }
  },
  methods:{
    edit(item){
      this.detail = {id:item.id,name:item.name};
      this.modal1 = true;
    },
    remove(id){
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要删除吗',
        onOk: () => {
          let that = this;
          this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
            that.toast(rs.data);
          });
        },
      });
    },
    save(){
      let that = this;
      let data = Object.assign({}, this.detail);
      this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
        that.toast(rs.data);
        if(rs.data.success){
          that.detail = {};
        }
      });
    },
    addpar(){
      this.detail = {name:'',pid:0,type:this.type};
      this.modal1 = true;
    },
    addson(){
      if(this.pid==0){
        this.$Message.warning('请先点击左侧一级分类，选中一个分类，然后再增加二级分类');
        return;
      }
      this.detail = {name:'',pid:this.pid,type:this.type};
      this.modal1 = true;
    },
    load(){
      this.list = [];
      let that = this;
      let params = [];
      params.push('t.pid@=@0')
      this.$axios.get('/api/ziliao/ziliaoFenlei/findall?page=1&limit=1000&params='+params).then(function(rs){
        that.list = rs.data.data;
      });
    },
    load2(pid){
      this.pid = pid;
      let that = this;
      this.list2 = [];
      let params = [];
      params.push('t.pid@=@'+pid)
      this.$axios.get('/api/ziliao/ziliaoFenlei/findall?page=1&limit=1000&params='+params).then(function(rs){
        that.list2 = rs.data.data;
      });
    },
    toast(data){
      if(data.success){
        this.load();
        this.load2(this.pid);
        this.$Message.success(data.msg);
      }else{
        this.$Message.error(data.msg);
      }
    }
  },
  created(){
    this.load();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ziliao/ZiliaoFenlei.vue